import { Box, Flex, Text } from '@chakra-ui/react';
import { faBoxArchive } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, useToast } from '@morressier/alembic';
import { useRevokeSubmissionWithdrawalRequest } from 'src/api/commands';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { IDecisionModalProps } from '../decisionModalHelper.js';

export const AuthorRevokeSubmissionWithdrawalRequest = ({
  onClose,
  submissionId,
  submissionContextId
}: IDecisionModalProps) => {
  const toast = useToast();
  const { refetchSubmission, organizationId } = useSubmissionData();

  const mutation = useRevokeSubmissionWithdrawalRequest({
    submissionId,
    organizationId,
    submissionContextId,
    invalidateSubmissionQueries: refetchSubmission
  });

  const handleConfirm = async () => {
    const res = await mutation.mutateAsync();

    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Withdrawal Request Reverted',
        description:
          'The Editors have been notified via email about this decision'
      });
      onClose();
    } else {
      toast({
        variant: 'error',
        title: 'Error reverting submission withdrawal request',
        description:
          res.message?.errors
            ?.map((err: { reason: string }) => err.reason)
            .join(', ') || 'Try again later!',
        isClosable: true
      });
    }
  };

  return (
    <Modal isOpen onClose={onClose} width="720px">
      <Flex padding={8} gap={6} flexDirection="column">
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faBoxArchive} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Flex alignItems="center">
            <Text textStyle="headingGroup">Revert Withdrawal Request?</Text>
          </Flex>
          <Text textStyle="textBody">
            Reverting your withdrawal request will reactivate your submission,
            continuing the publication process. The Editors will be notified of
            this change.
          </Text>
        </Flex>

        <Flex gap={2} justifyContent="flex-end">
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} isLoading={mutation.isLoading}>
            Confirm Decision
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
